/*------------------------------------*\
    FORM VALIDATOR
\*------------------------------------*/

WW.formValidator = function($) {
    'use strict';

    const regex = {
            email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
            name: /[_+,!@#$%^&*();\\\/|<>"']|\d/g
        },
        minLength = {
            name: 2
        },

        validate = (type, str, len) => {
            const types = {
                empty() {
                    return str === '';
                },
                email() {
                    return regex[type].test(str);
                },
                name() {
                    return !regex[type].test(str) && str.length >= minLength[type];
                }
            };

            return (types[type]) ? types[type](str) : null;
        };

    return {
        validate
    };
};